import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { HYDRATE } from 'next-redux-wrapper';

export const billboardApi = createApi({
  reducerPath: 'billboardApi',
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_API_EVENT}/checkout-billboards/api/v1`,
    prepareHeaders: (headers) => {
      headers.set('Cache-Control', 'no-cache');
      headers.set('Pragma', 'no-cache');
      headers.set('Expires', '0');
      headers.set('User-Agent', 'Mozilla/5.0 (compatible; CloudFront-Request/1.0)');
      return headers;
    },
  }),
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath];
    }
  },
  tagTypes: ['Billboards', 'BillboardsEvents'],
  keepUnusedDataFor: 30,
  endpoints: (build) => ({
    getBillboardByIdOrName: build.query({
      query: (value) => `billboard/${value}`,
      providesTags: ['Billboards'],
      keepUnusedDataFor: 0,
    }),
    getBillboardsEvents: build.query({
      query: (value) => `billboard/events/${value}`,
      providesTags: ['BillboardsEvents'],
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useGetBillboardByIdOrNameQuery,
  useLazyGetBillboardByIdOrNameQuery,
  useGetBillboardsEventsQuery,
  useLazyGetBillboardsEventsQuery,
  util: { getRunningQueriesThunk },
} = billboardApi;

export const { getBillboardByIdOrName } = billboardApi.endpoints;
